<template>
  <div class="itemListBox">
    <p v-if="ItemTotal" class="item-num">{{ItemTotal}}件のアイテム</p>    
    <ul class="itemList">
      <li v-for="item in ItemList">
        <itemimgbox v-bind:itemId="item.id"/>
        <div class="itmgenicon"><span v-bind:class="['genselicon', 'bg-gen-' + item.gender]"><img v-bind:src="['//cdn.sportsstyle.net/img/i/ic-gen-' + item.gender + '.svg']" width="12px" height="12px" alt="レディースのアイコン"></span></div>
        <div class="itmdtl">
          <p class="itmbdnm httl5 mh"><router-link :to="{ name: 'itemDetail', params: { id: item.id } }">{{item.brand_name_full}} <span class="itmnm">{{item.name}}</span></router-link class="plnlink"></h2>

          <p class="itmprc">
            ¥ {{item.min_price | addComma}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import lazysizes from 'lazysizes'
import itemimgbox from '@/components/items/itemimgbox.vue'

export default {
  props: ['ItemList', 'ItemTotal'],
  components: {
    itemimgbox,
  },
  methods: {
    getBrandCode(code) {
      return code;
    },
  }
}
</script>

<style scoped>
.item-num{text-align: center; margin: 6px 0 2px}
</style>
